import { render, staticRenderFns } from "./agentLoadingPlaceholder.vue?vue&type=template&id=0f4f02e7&scoped=true&"
import script from "./agentLoadingPlaceholder.vue?vue&type=script&lang=js&"
export * from "./agentLoadingPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./agentLoadingPlaceholder.vue?vue&type=style&index=0&id=0f4f02e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4f02e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f4f02e7')) {
      api.createRecord('0f4f02e7', component.options)
    } else {
      api.reload('0f4f02e7', component.options)
    }
    module.hot.accept("./agentLoadingPlaceholder.vue?vue&type=template&id=0f4f02e7&scoped=true&", function () {
      api.rerender('0f4f02e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/contextMenu/agentLoadingPlaceholder.vue"
export default component.exports